export enum ProjectTab {
  OVERVIEW = 0,
  MEMBERS = 2,
}

export enum ProjectAction {
  CREATE_OFFER = "0",
}
